var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".copy_svg__st0{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15c0-2.8 0-4.2.9-5.1S12.2 9 15 9h1c2.8 0 4.2 0 5.1.9s.9 2.3.9 5.1v1c0 2.8 0 4.2-.9 5.1s-2.3.9-5.1.9h-1c-2.8 0-4.2 0-5.1-.9S9 18.8 9 16z",
    className: "copy_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9c0-3 0-4.5-.6-5.5-.2-.2-.4-.4-.6-.5-1.4-1-3-1-6.3-1s-4.9 0-6 .9l-.6.6C2 4.6 2 6.2 2 9.5s0 4.9.9 6c.2.2.4.4.6.5 1 1 2.6 1 5.5 1",
    className: "copy_svg__st0"
  })));
};
export default SvgCopy;